import axios from 'axios';

const addSupplier = async (token, phone, name, profile_picture) => {

    var data = {
      "token": token,
      "phone": phone,
      "name": name,
      "profile_picture": profile_picture
    };
    
    const headers = { 
        'Content-Type': 'application/json',
    };

    // console.log(data);
    try {
        await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/add-supplier', data, { headers })
    }catch(err) {
        console.log(err);
        return false
    }
};

export default addSupplier